// this file is automatically generated by git.revision.js script
export const versions = { revision: '016b1aa02a' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '016b1aa02a';
